import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ImageModule } from '@df/module-image/image.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export namespace NCmsEcologiBanner {
    export const ID = 'ecologi-banner-block';
    export interface IBlockData extends Catalog.IBlockData<IBlockContent> {}
    export interface IBlockContent {
        copy: string;
        logo: string;
    }
}
@ICmsComponent<EcologiBannerBlockComponent>({
    id: NCmsEcologiBanner.ID,
    block: {
        url: NCmsEcologiBanner.ID
    },
    onDemandOnly: true,
    name: 'Ecologi Banner Block',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'copy',
            title: 'Copy',
            description: 'Percent sign will be replaced by number of trees',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'logo',
            type: NICmsContentField.EFieldType.image,
            title: 'Logo',
            required: true
        }
    ]
})
@Component({
    selector: 'ecologi-banner-block',
    templateUrl: './ecologi-banner-block.html',
    styleUrls: ['./ecologi-banner-block.scss'],
    standalone: true,
    imports: [ImageModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EcologiBannerBlockComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content: NCmsEcologiBanner.IBlockContent;
    @Input()
    numberOfTrees = 0;
    get copy(): string {
        return this.content?.copy?.replace('%', `${this.numberOfTrees} tree${this.numberOfTrees > 1 ? 's' : ''}`);
    }
    // custom warning if there is lack of % in config
    // protected getCantPrintWarning(): string {
    //     const getCantPrintWarning = super.getCantPrintWarning();
    //     return getCantPrintWarning ? getCantPrintWarning : this.content.copy?.includes('%') ? undefined : 'NEED PERCENT SIGN INSIDE COPY';
    // }
}
